import {Component, EventEmitter, Input, Output} from '@angular/core';
import {
  EditFormPageComponent
} from '@components/pages/page-components/form-page/modal/edit-form-page/edit-form-page.component';
import {FormPage} from '@models/sidebar/response/form-page';
import {cloneDeep} from 'lodash';
import {ModalService} from '@services/modal/modal.service';

@Component({
    selector: 'scitis-form-page-actions',
    templateUrl: './form-page-actions.component.html',
    styleUrls: ['./form-page-actions.component.scss'],
    standalone: false
})
export class FormPageActionsComponent {

  @Input()
  public formPageConfiguration: FormPage = new FormPage();
  @Input()
  public machineId: string = '';
  @Input()
  public isTechAdminOrHigher: boolean = false;

  @Output()
  public formPageConfigurationChange: EventEmitter<FormPage> = new EventEmitter<FormPage>();

  constructor(private modalService: ModalService) {
  }
  get disableEditButton() {
    if (!this.isTechAdminOrHigher) {
      return true;
    }

    if (!this.formPageConfiguration.id || this.formPageConfiguration.id < 1) {
      return true;
    }

    return false;
  }
  public onEditPage(): void {
    const modalRef = this.modalService.open(EditFormPageComponent, {
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.formPageConfiguration = cloneDeep(this.formPageConfiguration);
    modalRef.componentInstance.machineId = this.machineId;
    modalRef.result.then((result: FormPage) => {
      this.saveFormPageConfiguration(result);
    });
  }

  private saveFormPageConfiguration(result: FormPage) {
    this.formPageConfigurationChange.emit(result);
  }

}
